import { USER_TYPES } from '../enums';

const isRequester = state => state.user.model.userType === USER_TYPES.REQUESTER;

const isCallTypePcsRequired = service => {
  const { callTypeOptions, callTypeId } = service;
  if (!callTypeOptions?.length) return false;

  const callType = callTypeOptions.find(({ key }) => key === callTypeId);

  return callType?.pcsRequired;
};

const isServiceTypePcsRequired = service => {
  const { serviceId, serviceTypeLookup } = service;
  const serviceType = serviceTypeLookup?.[serviceId];
  return serviceType?.pcsRequired;
};

export const isAgencyGroupPcsEnabled = state => state.agency.requesterAgencyGroup?.pcsEnabled;

export const isAgencyGroupPcsMandatory = state => state.agency.requesterAgencyGroup?.pcsMandatory;

export const displayPCSButton = state => isRequester(state) && isAgencyGroupPcsEnabled(state);

export const hasPCSAttachment = state =>
  state.patientDocuments.attachments?.some(
    attachment => attachment.attachmentType && attachment.attachmentType.name === 'PCS',
  );

export const needsPCSForm = state =>
  isRequester(state) &&
  isAgencyGroupPcsEnabled(state) &&
  isCallTypePcsRequired(state.service) &&
  isServiceTypePcsRequired(state.service) &&
  !hasPCSAttachment(state);
